<script setup lang="ts">
const { size = 'xl', title } = defineProps<{
  title?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}>()

const sizeMap: Record<string, string> = {
  sm: 'text-sm',
  md: 'text-md',
  lg: 'text-lg',
  xl: 'text-xl',
}
</script>

<template>
  <span :class="sizeMap[size]" class="font-semibold">
    <slot>
      {{ title }}
    </slot>
    <slot name="suffix" />
  </span>
</template>
